/* eslint-disable no-plusplus */
export const getYearMonthFromISO = (ISODate: string) => ISODate.slice(0, 7);

export const convertToHumanDate = (
  date: Date,
  locale: string | undefined = 'en'
): string =>
  date.toLocaleString(locale, {
    month: 'long',
    year: 'numeric',
  });

export const generateDateItems = (
  {
    fromDate,
    toDate = new Date().toISOString(),
  }: {
    fromDate: string;
    toDate?: string;
  },
  locale: string = 'en'
): { human: string; iso: string }[] => {
  const dateItems = [];
  const [fromYear, fromMonth] = getYearMonthFromISO(fromDate)
    .split('-')
    .map(Number);
  const [toYear, toMonth] = getYearMonthFromISO(toDate).split('-').map(Number);

  for (let year = fromYear; year <= toYear; year++) {
    const endMonth = year !== toYear ? 11 : toMonth - 1;
    const startMon = year === fromYear ? fromMonth - 1 : 0;
    for (
      let month = startMon;
      month <= endMonth;
      month = month > 12 ? month % 12 || 11 : month + 1
    ) {
      const auxMonth = month + 1;
      const date = new Date(year, auxMonth - 1);
      const humanDate = convertToHumanDate(date, locale);
      const iso = `${year}-${String(auxMonth).padStart(2, '0')}`;
      dateItems.push({ human: humanDate, iso });
    }
  }

  return dateItems;
};
